import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import * as Yup from "yup"

export interface AgreementSignatoryFormValues {
  signerId: string
  companyDefault: boolean
}

const validationSchema = Yup.object().shape({
  signerId: Yup.string().required("Select someone to sign the agreement"),
})

/**
 * Allows reusability of agreement signatory form in different pages
 * Must be used in the FormProvider, as the submit functions are always in
 * a parent of the form wrapper
 * @param defaultSigner - default value for signer
 * @returns form methods
 */
export const useAgreementSignatoryForm = (defaultSignerId?: string) => {
  // Form
  const methods = useForm<AgreementSignatoryFormValues>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      signerId: defaultSignerId,
      companyDefault: false,
    },
  })

  const onCreateNewSigner = (signerId: string) => {
    methods.setValue("signerId", signerId)
    methods.clearErrors()
  }

  return {
    methods,
    onCreateNewSigner,
  }
}
